export { useDeleteTemplateInstance } from './useDeleteTemplateInstance';
